const checkinCatalog = new Set();

checkinCatalog
    .add('checkin-funnel-timeout')
    .add('checkin-funnel-error-modal')
    .add('checkin-funnel-error-redirect')
    .add('checkin-funnel-step-paxDetails')
    .add('checkin-funnel-step-seatsSelection')
    .add('checkin-funnel-step-providerFormTab')
    .add('checkin-funnel-step-result-success')
    .add('checkin-funnel-step-result-error')
    .add('checkin-form-load');

export default checkinCatalog;
